import * as React from 'react';
export const kriyaSvg = React.forwardRef(function kriyaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00293E',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm23.02 19.092.026.057 2.857 6.404a.317.317 0 0 1-.141.409.325.325 0 0 1-.154.038h-4.245a.325.325 0 0 1-.295-.19l-2.113-4.735a2.72 2.72 0 0 0-.15-.284c-.711-1.192-.2-2.364.707-2.967.907-.603 2.196-.625 3.038.48.186.245.344.51.47.788Z',
      fill: '#D059FF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.322 6h3.885a.32.32 0 0 1 .322.32v19.36a.32.32 0 0 1-.322.32H7.322A.32.32 0 0 1 7 25.68V6.32a.32.32 0 0 1 .322-.318Z',
      fill: '#00E043',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm14.423 13.504 6.433-7.393a.322.322 0 0 1 .244-.11h4.689a.325.325 0 0 1 .292.185.315.315 0 0 1-.047.34l-8.392 9.71c-1.28 1.481-3.733.586-3.733-1.364 0-.502.182-.987.514-1.368Z',
      fill: '#FFC800',
    }),
  );
});
kriyaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kriya = {
  category: 'brand',
  colorable: false,
  name: 'kriya',
  svg: kriyaSvg,
};
